import { jsx } from "panel";
import { selx } from "clsx";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { ProgressBarEl } from "common/components/progress-bar";
import styles from "./index.module.styl";
import { CALENDLY_URL, OnboardingChecklistTrackingEvent } from "./types";
import { OnboardingChecklistSurveyEl } from "./survey";
export function template() {
  if (this.state.showSurvey) {
    return /* @__PURE__ */ jsx(OnboardingChecklistSurveyEl, { params: {
      onActionCallback: () => {
        this.params.completeCallback();
      },
      email: this.params.userEmail,
      orgId: this.getOrgId()
    } });
  }
  const Step = (props) => {
    const {
      label,
      completed,
      header,
      body,
      onClick
    } = props;
    const leftIcon = completed ? /* @__PURE__ */ jsx(SvgIconEl, { sel: selx(styles.checkmark), attrs: {
      icon: "checkmark"
    } }) : /* @__PURE__ */ jsx("div", { sel: selx(styles.label) }, label);
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: selx(styles.step, styles.hoverable), on: {
      click: (ev) => {
        ev.stopPropagation();
        onClick();
      }
    } }, /* @__PURE__ */ jsx("div", { sel: selx(styles.content) }, /* @__PURE__ */ jsx("div", { sel: selx(styles.leftColumn) }, leftIcon), /* @__PURE__ */ jsx("div", { sel: selx(styles.description) }, /* @__PURE__ */ jsx("div", { sel: selx(styles.header) }, header), /* @__PURE__ */ jsx("div", { sel: selx(styles.body) }, body)))));
  };
  const ChecklistSteps = () => {
    const steps = this.steps().map((step) => {
      return /* @__PURE__ */ jsx(Step, { ...step });
    });
    return /* @__PURE__ */ jsx("div", { sel: selx(styles.gap, styles.checklists), attrs: {
      collapsed: !this.state.expanded
    }, "data-sentry-component": "ChecklistSteps", "data-sentry-source-file": "template.tsx" }, steps, /* @__PURE__ */ jsx("a", { attrs: {
      href: CALENDLY_URL,
      target: "_blank"
    } }, /* @__PURE__ */ jsx("div", { sel: selx(styles.helpButton), on: {
      click: (ev) => {
        this.track(OnboardingChecklistTrackingEvent.Calendly, {
          "Completed Implementation": this.state.status.Implementation
        });
        ev.stopPropagation();
      }
    } }, /* @__PURE__ */ jsx("span", { sel: selx(styles.header) }, "Need help?"), /* @__PURE__ */ jsx("span", null, "Connect with a member of our team"))), !this.completedChecklist() && /* @__PURE__ */ jsx(ButtonEl, { attrs: {
      theme: ButtonTheme.Tertiary
    }, on: {
      click: () => {
        this.params.dismissCallback();
        this.track(OnboardingChecklistTrackingEvent.Dismiss);
      }
    } }, "Dismiss"));
  };
  const CelebrationActions = () => {
    return /* @__PURE__ */ jsx("div", { sel: selx(styles.celebrationCta), "data-sentry-component": "CelebrationActions", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ButtonEl, { sel: selx(styles.fillButton), on: {
      click: () => {
        this.track(OnboardingChecklistTrackingEvent.Finish);
        this.update({
          showSurvey: true
        });
      }
    }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Finish"), /* @__PURE__ */ jsx(ButtonEl, { sel: selx(styles.fillButton), attrs: {
      theme: ButtonTheme.Primary
    }, on: {
      click: this.invite
    }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Invite a teammate"));
  };
  const ProgressBar = () => {
    const statusKeys = Object.keys(this.state.status);
    const total = statusKeys.length;
    const completed = statusKeys.reduce((c, k) => {
      if (this.state.status[k]) {
        c += 1;
      }
      return c;
    }, 0);
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: selx(styles.progressStatus) }, completed, " of ", total, " steps completed ", this.completedChecklist() && "\u{1F44F}\u{1F44F} \u2014 Nice work!"), /* @__PURE__ */ jsx(ProgressBarEl, { attrs: {
      percent: completed / total * 100
    }, "data-sentry-element": "ProgressBarEl", "data-sentry-source-file": "template.tsx" }));
  };
  const Celebration = () => {
    return this.completedChecklist() && /* @__PURE__ */ jsx("div", { sel: selx(styles.celebrationCard), attrs: {
      collapsed: !this.state.showCelebrationPeek && !this.state.expanded
    } }, /* @__PURE__ */ jsx("div", { sel: selx(styles.celebrationStep) }, /* @__PURE__ */ jsx("div", { sel: selx(styles.content) }, /* @__PURE__ */ jsx("div", { sel: selx(styles.leftColumn, styles.iconSize) }, "\u{1F389}"), /* @__PURE__ */ jsx("div", { sel: selx(styles.description) }, /* @__PURE__ */ jsx("div", { sel: selx(styles.header) }, "Congratulations"), /* @__PURE__ */ jsx("div", { sel: selx(styles.body) }, "Share your new board with your teammates when you're ready."))), /* @__PURE__ */ jsx(CelebrationActions, null)));
  };
  const Header = () => {
    return /* @__PURE__ */ jsx("div", { sel: selx(styles.header), "data-sentry-component": "Header", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: selx(styles.text) }, "Onboarding Guide"), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
      icon: this.state.expanded ? "caret-down" : "caret-up",
      theme: ButtonTheme.Tertiary
    }, on: {
      click: (ev) => {
        ev.stopPropagation();
        this.update((prevState) => ({
          expanded: !prevState.expanded
        }));
      }
    }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }));
  };
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.container), on: {
    mouseenter: () => {
      if (this.completedChecklist() && !this.state.expanded) {
        this.update({
          showCelebrationPeek: true
        });
      }
    },
    mouseleave: () => {
      if (this.state.showCelebrationPeek && !this.state.expanded) {
        this.update({
          showCelebrationPeek: false
        });
      }
    },
    click: () => {
      this.update((prevState) => ({
        expanded: !prevState.expanded
      }));
    }
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(Header, { "data-sentry-element": "Header", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(ProgressBar, { "data-sentry-element": "ProgressBar", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(Celebration, { "data-sentry-element": "Celebration", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(ChecklistSteps, { "data-sentry-element": "ChecklistSteps", "data-sentry-source-file": "template.tsx" }));
}
